import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Tooltip } from '@shared/Tooltip';
import Info from '../../../images/info.inline.svg';
import { LINKS_COLOR } from '../../../theme';
import { isMobile } from '../../../constants';

const Content = styled.span`
  display: flex;
  align-items: center;
`;

const InfoIcon = styled(Info)`
  width: 24px;
  height: 24px;
  display: block;
  fill: ${LINKS_COLOR};
`;

const TextareaInfo = (props) => {
  const { tooltipContent } = props;
  return (
    <Content>
      En manque d&apos;inspiration
      <Tooltip
        position="top right"
        trigger={isMobile ? 'click' : 'hover'}
        content={tooltipContent}
        width={200}
      >
        <InfoIcon />
      </Tooltip>
    </Content>
  );
};

TextareaInfo.propTypes = {
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export { TextareaInfo };
